const dist = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};

export const getPath = (x1,y1,x2,y2, isHorizontal) => {
    let y_a = 40;
    let y_b = 40;
    if (y2 < y1) {
        y_a = 80;
    }

    if (isHorizontal) {
        return [
            x1, y1,
            x1, y1 + y_a,
            x2 - y_b, y2,
            x2, y2,
        ];
    } 

    return [
        x1, y1,
        x1, y1 + y_a,
        x2, y2 - y_b,
        x2, y2];
};
